import React from 'react';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import { createBrowserHistory } from 'history';
import { ToastContainer } from 'react-toastify';

import { LocalizeProvider } from "react-localize-redux";
import { setupInterceptors, setupAuthWatch, setupResizeDispatcher } from './store/apiWrapper'
import { setupClickDispatcher } from './store/clickWrapper'
import { setupTheme, setupFontSize, setupFont, hookListener } from './store/displaySettingsStore'
import configureStore from './store/configureStore';

import App from './app';
import MasterSvg from './components/layoutItems/masterSvg.jsx';
import PopupContainer from './components/common/popupContainer';
import WindowManager from './components/common/windowManager';
import AutoLogout from './components/common/autoLogout.jsx';

const history = createBrowserHistory({ basename: document.getElementsByTagName('base')[0].getAttribute('href') });
const store = configureStore(history, window.initialReduxState);
setupInterceptors(store, history);
setupAuthWatch(store, history);
setupClickDispatcher(store)
setupResizeDispatcher(store);
setupTheme();
setupFontSize();
setupFont();
hookListener(store);

class AppLoader extends React.Component {
    render (){
        return (
            <Provider store={store}>
                <LocalizeProvider store={store}>
                    <ConnectedRouter history={history}>
                        <React.Fragment>
                            <div style={{ width: 0, height: 0 }}>
                                <MasterSvg />
                            </div>
                            <AutoLogout/>
                            <App />
                            <ToastContainer />
                            <PopupContainer />
                            <WindowManager />
                        </React.Fragment>
                    </ConnectedRouter>
                </LocalizeProvider>
            </Provider>
        );
    }
}

export default AppLoader;